import { render, staticRenderFns } from "./BlockChecklistEl.vue?vue&type=template&id=4d92f75c&scoped=true&"
import script from "./BlockChecklistEl.vue?vue&type=script&lang=ts&"
export * from "./BlockChecklistEl.vue?vue&type=script&lang=ts&"
import style0 from "./BlockChecklistEl.vue?vue&type=style&index=0&id=4d92f75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92f75c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
